export default {
  subtitle: "Inviamo gli eventi selezionati ai tuoi endpoint tramite POST, firmati con il secret dell'endpoint.",
  regenerate_confirm: 'Generare un nuovo secret di firma? Il secret attuale smetterà di funzionare immediatamente.',
  delete_confirm: 'Eliminare questo endpoint? Smetterà di ricevere eventi.',
  consecutive_failures: '{{count}} errori consecutivi',
  columns: {
    url: 'Endpoint',
    events: 'Eventi',
    status: 'Stato',
    secret: 'Secret',
  },
  statuses: {
    active: 'Attivo',
    disabled: 'Disabilitato',
    auto_disabled: 'Disabilitato automaticamente',
  },
  buttons: {
    create: 'Aggiungi endpoint',
    edit: 'Modifica',
    regenerate_secret: 'Nuovo secret',
    delete: 'Elimina',
  },
  toasts: {
    load_error: 'Impossibile caricare gli endpoint webhook.',
    error: 'Qualcosa è andato storto. Riprova.',
    deleted: 'Endpoint eliminato.',
  },
};
